<template>
  <PageHeader>
    <template #header-title>
      {{ $t('Hires') }}
    </template>
    <template #header-actions>
      <WdsStack class="tw-mb-2" direction-column gap-md align-end>
        <WdsStack class="tw-mb-2" direction-row gap-md align-center>
          <WdsButton :href="laravelNamedRoute('frontend.flows.hiring.actions')" primary>
            <WdsStack gap-sm align-center justify-center>
              <WdsIcon :name="WdsIconNameEnum.PLUS" />
              {{ $t('New Hire') }}
            </WdsStack>
          </WdsButton>
        </WdsStack>

        <WdsStack direction-row gap-xs align-end>
          <a href="#" @click="showLearnMoreModal = true">
            {{ $t('Learn more') }}
          </a>

          <span>{{ $t('about hire statuses') }}</span>
        </WdsStack>
      </WdsStack>
    </template>
  </PageHeader>

  <HiresGraphqlTable />

  <HireComplianceStatusCompanyModal
    :open="showLearnMoreModal"
    @close="showLearnMoreModal = false"
  />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import {
  WdsButton,
  WdsIcon,
  WdsIconNameEnum,
  WdsStack,
} from '@worksome/wds-components'
import PageHeader from '@/components/PageHeader.vue'
import { $t } from '@/composables/translation'
import HiresGraphqlTable from '@/components/Hire/HiresGraphqlTable.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import HireComplianceStatusCompanyModal from '@/components/Hire/HirePageCompliance/HireComplianceStatusCompanyModal.vue'

const showLearnMoreModal = ref(false)
</script>
